export const locales = ["en", "ru", "tr"] as const;
export type Locale = (typeof locales)[number];

export const products = ["rotating-residential", "rotating-datacenter", "static-isp"] as const;

export type ProductType = (typeof products)[number];

export type Heading = {
  tag: string;
  text: string;
  anchor: string;
};

export type Content = {
  rendered: string;
  plain: string; // Added "plain" for plain text versions of title and excerpt
};

export type Meta = {
  footnotes: string;
};

export type WordpressPost = {
  // Core post metadata
  id: number;
  slug: string;
  date: string;
  date_gmt: string;
  modified: string;

  // Title and content
  title: Content; // Includes both rendered and plain
  content: Content; // Includes only rendered
  excerpt: Content; // Includes both rendered and plain

  // Taxonomy and tags
  tags: string[];
  tag_slugs: string[];

  // Media and additional attributes
  featured_media_src_url: string | null;

  // Structured data and references
  headings: Heading[];
  referenced_products: ProductType[];

  // Custom fields
  meta: Meta;
  plan_title: string;
};
